import { FillPaint, LinePaint } from 'mapbox-gl';

interface FillZones {
  default: FillPaint;
  selected: FillPaint;
  hovered: FillPaint;
}

interface OutlineZone {
  default: LinePaint;
  selected: LinePaint;
  hovered: LinePaint;
}

interface ZonesLayers {
  fill: FillZones;
  outline: OutlineZone;
}

export const zonesLayers: ZonesLayers = {
  fill: {
    default: {
      'fill-color': ['get', 'color'],
      'fill-opacity': [
        'case',
        ['boolean', ['feature-state', 'hover'], false],
        0.7,
        ['get', 'opacity'],
      ],
      'fill-opacity-transition': {
        duration: 300,
      },
    },
    selected: {
      'fill-color': '#eb8334',
      'fill-opacity': 0.75,
    },
    hovered: {
      'fill-color': '#fcca03',
      'fill-opacity': 0.5,
    },
  },
  outline: {
    default: {
      'line-color': ['get', 'color'],
      'line-width': 2,
    },
    selected: {
      'line-color': '#b06227',
      'line-width': 2,
    },
    hovered: {
      'line-color': '#fcca03',
      'line-width': 2,
    },
  },
};
